import { html, render } from 'lit-html';
import MicroModal from 'micromodal';

const CommonModal = (window as any)._modal;

class ConfirmModal extends CommonModal {
  private static instance: ConfirmModal;

  readonly OPEN_CLASS = 'is-open';
  readonly ARIA_HIDDEN = 'aria-hidden';
  readonly CONFIRM_HTML_ID = 'modal_util_confirm_modal';

  private constructor() {
    // Override data-micromodal-trigger
    super('data-common-confirm-trigger');
  }

  static getInstance = () => {
    if (!ConfirmModal.instance) {
      ConfirmModal.instance = new ConfirmModal();
    }
    return ConfirmModal.instance;
  };

  render = (content: string, btnText: string, callback: CallbackFunc) => {
    render(this.renderConfirm(content, btnText, callback), this.getElementToRender());
    // dynamic init
    // links no need to define `data-common-confirm-trigger="modal_util_confirm_modal"`
    ConfirmModal.getInstance().openDialog();
  };

  private renderConfirm = (content: string, btnText: string, callback: CallbackFunc) => html`
    <div class="o-simplemodal" id="${this.CONFIRM_HTML_ID}" aria-hidden="true">
      <div class="o-simplemodal_bg js-horizontalFixedScroll" tabindex="-1">
        <div class="o-contentWidth -width700">
          <div class="o-simplemodal_container">
            <div class="o-simplemodal_inner">
              <div
                role="dialog"
                aria-modal="true"
                aria-describedby="modal-common-confirm-content"
                class="o-simplemodal_body"
              >
                <div
                  class="o-simplemodal_main"
                  id="modal-common-confirm-content"
                  aria-labelledby="modal-common-confirm-content"
                >
                  <div class="a-heading -typeh5 u-mb-24">
                    <h2 class="a-heading_text">${content}</h2>
                  </div>
                  <div class="o-colBox -jccenter -aicenter -margin8 -fdcolumn-reverse-sp">
                    <button
                      class="m-btn -short"
                      type="button"
                      @click=${() => {
                        this.closeDialog();
                      }}
                    >
                      <span class="m-btn_inner">
                        <span class="m-btn_text">キャンセル</span>
                      </span>
                    </button>
                    <a
                      href="javascript:;"
                      class="m-btn -red -short"
                      @click=${() => {
                        callback();
                        this.closeDialog();
                      }}
                    >
                      <span class="m-btn_inner">
                        <span class="m-btn_text">${btnText}</span>
                      </span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  private openDialog = () => {
    const el = document.querySelector(`#${this.CONFIRM_HTML_ID}`);
    if (el) {
      el.setAttribute(this.ARIA_HIDDEN, 'false');
      el.classList.add(this.OPEN_CLASS);
    }
  };

  private closeDialog = () => {
    const el = document.querySelector(`#${this.CONFIRM_HTML_ID}`);
    if (el) {
      el.setAttribute(this.ARIA_HIDDEN, 'true');
      el.classList.remove(this.OPEN_CLASS);
    }
  };

  private getElementToRender = () => {
    const wrapperId = `${this.CONFIRM_HTML_ID}_wrapper`;
    let elementToRenderAt = document.querySelector(`#${wrapperId}`) as HTMLElement;
    if (!elementToRenderAt) {
      elementToRenderAt = document.createElement('div');
      elementToRenderAt.setAttribute('id', wrapperId);
      // 動的にpc/sp/rw(responsive)画面を特定する
      if (document.querySelector('.is-sp-page')) {
        elementToRenderAt.classList.add('is-sp-page');
      } else if (document.querySelector('.is-rw-page')) {
        elementToRenderAt.classList.add('is-rw-page');
      } else {
        elementToRenderAt.classList.add('is-pc-page');
      }

      document.body.appendChild(elementToRenderAt);
    }
    return elementToRenderAt;
  };
}

type CallbackFunc = () => void;

const confirm = (content: string, btnText: string, callback: CallbackFunc) => {
  ConfirmModal.getInstance().render(content, btnText, callback);
};

const show = (targetId: string) => {
  MicroModal.show(targetId, {});
};

const ModalUtil = {
  confirm,
  show
};
export default ModalUtil;
